import { Box, Button, Typography } from '@mui/material';
import { WarningIcon, XIcon } from '@phosphor-icons/react';
import { useImpersonation } from '../context/ImpersonationContext.js';
import { useCurrentZubeAgentUser } from '../utils/api.js';

export const IMPERSONATION_BANNER_HEIGHT = 56;

export default function ImpersonationBanner() {
  const { isImpersonating, stopImpersonation } = useImpersonation();
  const { data: agentUser } = useCurrentZubeAgentUser({ showErrorSnackbar: false });

  if (!isImpersonating) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: IMPERSONATION_BANNER_HEIGHT,
        zIndex: 9999,
        backgroundColor: '#ff9800',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          width: '100%',
          maxWidth: 1200,
        }}
      >
        <WarningIcon size={24} color="white" weight="fill" />
        <Typography
          variant="body1"
          sx={{
            color: 'white',
            fontWeight: 600,
            flexGrow: 1,
          }}
        >
          Impersonating: {agentUser?.data.email || 'Client User'}
        </Typography>
        <Button
          variant="contained"
          onClick={stopImpersonation}
          startIcon={<XIcon size={18} />}
          sx={{
            backgroundColor: 'white',
            color: '#ff9800',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          Exit Impersonation
        </Button>
      </Box>
    </Box>
  );
}
